module.exports = __webpack_public_path__ + "img/shipinhao.d8b727bc.jpg";